import { COMMISSIONS_POLICIES_CLEAR_STOCK_OPORTUNITY } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_CLEAR_STOCK_OPORTUNITY) {
      return {
        ...state,
        policies: {
          ...state.policies,
          stockData: [],
          brands: [],
          stockLoading: false,
          stockFailure: false
        }
      }
  }
  else {
      return state
  }
}
